<!--<mat-label>Moeda</mat-label> {{POR O VALOR AQ INPUT}} -->
<mat-form-field appearance="fill">
    <mat-select data-test="select-moeda" required [value]="currentCurrencyCompany" (selectionChange)="currencySelected($event.value)">
        <mat-option *ngFor="let currency of currencies" [value]="currency" [attr.data-test]="'opcao-moeda-' + currency.code">
            {{currency.name}}
        </mat-option>
    </mat-select>
</mat-form-field>